import { Link } from "react-router";
import { ShieldAlert } from "lucide-react";
import { landingFor, PERMISSIONS, type Requirement } from "@/domain/rbac";
import { useMe } from "@/data/queries";
import { buttonVariants } from "@/components/ui/Button";
import { tr } from "@/i18n/i18n";

export default function ForbiddenPage({ require }: { require?: Requirement }) {
  const { data: me } = useMe();
  const list = require ? (Array.isArray(require) ? require : [require]) : [];
  const labels = list.map((p) => tr(PERMISSIONS.find((x) => x.id === p)?.label ?? p));
  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-3 py-16 text-center">
      <ShieldAlert className="size-10 text-danger" aria-hidden />
      <h1 className="text-xl font-semibold">{tr("You don’t have access to this screen")}</h1>
      {labels.length > 0 ? (
        <p className="text-sm text-muted">{tr("Requires:")}{" "}{labels.join(` ${tr("or")} `)}.</p>
      ) : (
        <p className="text-sm text-muted">{tr("This screen is for developers only.")}</p>
      )}
      <p className="text-xs text-muted">{tr("This attempt has been logged.")}</p>
      <Link to={landingFor(me)} className={buttonVariants({ variant: "secondary" })}>
        {tr("Back to my workspace")}
      </Link>
    </div>
  );
}
